export function setDidomiConfig() {
  window.didomiConfig ||= {}
  window.didomiConfig.user ||= {}
  window.didomiConfig.user.bots ||= {}
  window.didomiConfig.user.externalConsent ||= {}
  window.didomiConfig.cookies ||= {}
  window.didomiConfig.user.bots.consentRequired = false
  window.didomiConfig.user.externalConsent.enabled = true
  window.didomiConfig.cookies.storageSources = {cookies: true, localStorage: false}
}
